import { useQuery } from '@tanstack/react-query';
import { fetchPlatformMessages } from './api';

export function usePlatformMessages() {
  return useQuery({
    queryKey: ['platform-messages'],
    queryFn: fetchPlatformMessages,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
